import React, { useState } from 'react';
import Nav from './Nav';
import { Link, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

export default function SideBar({ fullMenu }) {
  const [headerOpen, toggleHeader] = useState(false);
  const data = useStaticQuery(graphql`
    query {
      file(name: { eq: "portrait" }) {
        id
        childImageSharp {
          fluid(maxHeight: 80, maxWidth: 80, fit: OUTSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <>
      <header id="header" className={`${fullMenu ? '' : 'alt'}`}>
        <Link to="/">
          <Img
            style={{
              borderRadius: '100%',
              border: '2px solid rgba(255, 255, 255, 0.125)',
              height: '3em',
              width: '3em',
              marginTop: '1em',
            }}
            fluid={data.file.childImageSharp.fluid}
            alt="Milian Schenk"
          />
        </Link>

        <nav>
          <a
            href="#menu"
            onClick={e => {
              e.preventDefault();
              toggleHeader(!headerOpen);
            }}
            className="menuToggle"
          >
            <span>Menu</span>
          </a>
        </nav>
      </header>
      <div className={`${headerOpen ? 'is-menu-visible' : ' '}`}>
        <Nav onMenuToggle={() => toggleHeader(!headerOpen)} />
      </div>
    </>
  );
}
